import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        margin: 10
    },
    gridTitle: {
        textAlign: 'center',
        paddingBottom: 40
    },
}))
